// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("modernizr/modernizr.custom.js");
require("@rails/ujs").start();
//--- Bootstrap
import $ from 'jquery';
import 'bootstrap';
import appInit from './angle/app.init.js';
//Added this to make sure the system response js correctly within the system.
document.addEventListener('DOMContentLoaded', appInit);
import '../stylesheets/application';

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
jQuery(function() {
  $('form').on('click', '.remove_fields', function(event) {
    $(this).prev('input[type=hidden]').val('1');
    $(this).closest('fieldset').hide();
    return event.preventDefault();
  });
  $('form').on('click', '.add_fields', function(event) {
    var regexp, time;
    time = new Date().getTime();
    regexp = new RegExp($(this).data('id'), 'g');
    $(this).before($(this).data('fields').replace(regexp, time));
    // console.log("add_filed clicked");
    var searchable = $(this).prev().find('select.i18n-searchable');
    if (searchable) {
      searchable.trigger('click');
    }
    return event.preventDefault();
  });
  $('form').on('click', '.remove_fields_in_table', function(event) {
    $(this).prev('input[type=hidden]').val('1');
    $(this).closest('tr').hide();
    return event.preventDefault();
  });
  return $('form').on('click', '.add_fields_in_table', function(event) {
    var regexp, time;
    time = new Date().getTime();
    regexp = new RegExp($(this).data('id'), 'g');
    $(this).parent().parent().before("<tr>" + ($(this).data('fields').replace(regexp, time)) + "</tr>");
    var searchable = $(this).parent().parent().prev().find('select.i18n-searchable');
    if (searchable) {
      searchable.trigger('click');
    }
    return event.preventDefault();
  });
});

$(document).ready(function() {
  return $(".close-announcement").click(function() {
    return $(this).closest(".alert").hide();
  });
});

$(document).ready(function() {
  $('[name="setting-theme"]').click(function(e) {
    var d = new Date();
    d.setTime(d.getTime() + (10 * 365 * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toGMTString();
    // if no path setting, each controller with have its own theme
    // document.cookie = 'p_system_theme=' + $(this).val() + "; " + expires; 
    // set same path, then all page will use same theme
    document.cookie = 'p_system_theme=' + $(this).val() + "; " + expires + "; " + "path=/";
  });
  
  $('form').on('keypress', '.prevent_enter', function(event) {
    if (event.keyCode == 13) {
      event.preventDefault();
    }
  });
  
  $('.call_modal').on('click', function(event) {
    $('#' + $(this).data('target')).modal();
  });
});
